<app-modal
  modalId="mediaSolutionModal"
  (closeModal)="closeModal()"
  *ngIf="this.solutionService.selectedMediaFile()"
>
  <ng-container *ngIf="this.solutionService.selectedMediaFile().url">
    <ng-container *ngIf="isSupported; else unsupported">
      <ng-container [ngSwitch]="true">
        <ng-template [ngSwitchCase]="isImage">
          <div class="image-wrapper">
            <img
              class="rounded mx-auto d-block"
              *ngIf="solutionService.selectedMediaFile().url"
              [src]="solutionService.selectedMediaFile().url"
            />
          </div>
        </ng-template>

        <ng-template [ngSwitchCase]="isVideo">
          <div class="video-wrapper">
            <video
              *ngIf="solutionService.selectedMediaFile().url"
              [src]="solutionService.selectedMediaFile().url"
              type="video/mp4"
              autoplay
              controls
            ></video>
          </div>
        </ng-template>

        <ng-template [ngSwitchCase]="isPdf">
          <div class="pdf-wrapper">
            <iframe
              *ngIf="solutionService.selectedMediaFile().url"
              [src]="solutionService.selectedMediaFile().url"
              frameboarder="0"
            ></iframe>
          </div>
        </ng-template>
      </ng-container>
    </ng-container>
  </ng-container>

  <ng-template #unsupported>
    <p>Das Dateiformat wird nicht unterstützt.</p>
  </ng-template>
</app-modal>
